import React, { useEffect } from 'react';
import NavBar from '../components/navigation/NavBar';
import Map from '../components/common/Map';
import InfoList from '../components/common/InfoList';
import { CourseFew, ServiceData } from '../components/common/Data';
import CourseInfo from '../components/common/CourseInfo';
import style from '../css/Service.module.css';
import ServiceList from '../components/common/ServiceList';
import Footer from '../components/common/Footer';
import BottomNav from '../components/navigation/BottomNav';

function Service() {
	useEffect(() => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	}, []);
	return (
		<div>
			<div className="sticky">
				<NavBar />
			</div>
			<Map />

			<ServiceList data={ServiceData} />

			<p className={style.head}>Our Top Courses </p>
			<CourseInfo coursedata={CourseFew} />
			<InfoList />
			<Footer />
			<div className="sticky_mob">
				<BottomNav />
			</div>
		</div>
	);
}

export default Service;
